export const upsertParticipant = (currentList, newParticipant) => {
    const index = currentList.findIndex(p => p.id === newParticipant.id);

    if (index !== -1) {
        // Mise à jour (On crée une copie propre)
        const newList = [...currentList];
        newList[index] = newParticipant;
        return newList;
    }

    // Ajout
    return [...currentList, newParticipant];
};